const _ = require('lodash')
const {createRefToCommon} = require('../commonSchemaUtils')

/**
 * @param {string[]} propertyPaths
 * @returns {string}
 */
const buildVariableConnectionsPattern = propertyPaths => `^(?:${propertyPaths.join('|')})$`

/**
 * @param {string[]} propertyPaths
 * @param {string} variableName
 * @returns {*}
 */
const buildVariableConnectionsItem = (propertyPaths, variableName) => ({
    type: 'object',
    properties: {
        path: {
            type: 'string',
            pattern: buildVariableConnectionsPattern(propertyPaths)
        },
        variableId: {
            shouldCollect: false,
            shouldValidate: true,
            referencedMap: 'variables',
            $ref: createRefToCommon('reference'),
            refTypes: [variableName]
        }
    }
})

/**
 *
 * @param {*} singleNodeVariableConnections
 * @returns {{type: string, properties: {variableConnections: {type: string, items: {anyOf: *}}}}}
 */
const buildVariableConnectionsForSchema = singleNodeVariableConnections => {
    return {
        type: 'object',
        properties: {
            variableConnections: {
                type: 'array',
                items: {
                    anyOf: _.map(singleNodeVariableConnections, buildVariableConnectionsItem)
                }
            }
        }
    }
}
/**
 * @param {*} variableConnectionsMap
 * @param {string} dataNodeType
 * @param {string} namespace
 * @returns {*}
 */
const buildVariableConnections = (variableConnectionsMap, dataNodeType, namespace) => {
    const dataNodeVariableConnections = variableConnectionsMap?.[namespace]?.[dataNodeType]
    if (!dataNodeVariableConnections) return

    return buildVariableConnectionsForSchema(dataNodeVariableConnections)
}

module.exports = {
    buildVariableConnections,
    buildVariableConnectionsForSchema
}
